export default "__VITE_ASSET__7fbe05d8__"